import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import RootContainer from './containers/RootContainer';
import env from './env';
import { FORBIDDEN_PATH, UNAUTHORIZED_PATH } from './constants';
import ProductListContainer from './containers/products/ProductListContainer';
import LogoutContainer from './containers/LogoutContainer';
import NoPermissionContainer from './containers/NoPermissionContainer';
import PageNotFound from './containers/PageNotFoundContainer';
import IssueDetailsContainer from './containers/Issues/IssueDetailsContainer';
import IssueListContainer from './containers/Issues/IssueListContainer';
import UnauthorizedContainer from './containers/UnauthorizedContainer';
import JobListContainer from './containers/jobs/JobListContainer';
import JobDetailsContainer from './containers/jobs/JobDetailsContainer';
import UsersAndRolesContainer from './containers/users/UsersAndRolesContainer';
import XMLEditortContainer from './containers/editor/XMLEditortContainer';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Routes that DON'T require authentication - outside RootContainer */}
      <Route path={FORBIDDEN_PATH} element={<NoPermissionContainer />} />
      <Route path={UNAUTHORIZED_PATH} element={<UnauthorizedContainer />} />
      {/* Outside withAuth so expired sessions can still complete OIDC signOut */}
      <Route path={'logout'} element={<LogoutContainer />} />
      <Route path={env.OIDC_REDIRECT_URI} element={null} />
      <Route path={env.OIDC_REFRESH_URI} element={null} />

      {/* Routes that require authentication - inside RootContainer */}
      <Route
        path={'/'}
        errorElement={<PageNotFound />}
        element={<RootContainer />}
      >
        <Route path={'/'} element={<ProductListContainer />} />

        <Route path={'/jobs'} element={<JobListContainer />} />
        <Route path={'/jobs/:job_id'} element={<JobDetailsContainer />} />

        <Route path={'/issues'} element={<IssueListContainer />} />
        <Route path={'/question/:questionId/jira/:jiraId/xml'} element={<XMLEditortContainer />} />
        <Route path="/jira-id/:jiraId/question-id/:questionId" element={<IssueDetailsContainer />} />
        <Route path="/jira-id/:jiraId/case-id/:caseId/question-id/:questionId" element={<IssueDetailsContainer />} />
        <Route path="/jira-id/:jiraId/question-id/:questionId/was-issue/:wasIssueId" element={<IssueDetailsContainer />} />
        <Route path="/jira-id/:jiraId/case-id/:caseId/question-id/:questionId/was-issue/:wasIssueId" element={<IssueDetailsContainer />} />

        <Route path={'/users'} element={<UsersAndRolesContainer />} />
      </Route>
    </>,
  ),
);

export default router;
